export default "__VITE_ASSET__OFj_5J_W__"